import { Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Article } from '../../models/knowledge-base';
import { InstanceTypes } from '../../models/instance-types';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteParamsService } from '../../services/route-params.service';

@Component({
  selector: 'kb-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  standalone: false
})
export class ArticleComponent implements OnInit {
  @Input() article: Article;
  public announcement: boolean;
  public updatedDate: string;
  public articleHtml: SafeHtml;
  public articleTitle: string;
  private clientCode: string;
  constructor(
    private sanitizer: DomSanitizer,
    @Inject('env') private env: any,
    private routeParams: RouteParamsService
  ) {}
  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }
  ngOnInit(): void {
    this.routeParams.getParam('client_code').subscribe(x => {
      this.clientCode = x;
    });
    this.announcement = this.article.Tags?.includes('Announcement');

    // task 9699 - use seo data's description and title
    // Zoho doesn't have direct replacements, so updated to use regular title and Summary
    // Freshdesk model was revised to use seo_data['meta_description'] to drive Summary
    this.articleTitle = this.article.Title;
    this.articleHtml = this.sanitizer.bypassSecurityTrustHtml(this.article.Summary);

    this.updatedDate = new Date(this.article.UpdatedAt).toLocaleDateString('en-us', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }

  public goToFullArticle() {
    let url = '';
    if (this.isClientPortal) {
      url += `${this.clientCode}/`;
    }
    url += `knowledge-base/article/${this.article.Id}`;
    window.open(url, '_blank');
  }
}
